// extracted by mini-css-extract-plugin
export var attachmentContainer = "_k8-0";
export var fileList = "_k8-2";
export var removeFileButton = "_k8-1";